export default {
  coupon: {
    selectCoupons: '選擇優惠券',
    tips: '最佳優惠推薦使用<span class="orange-text">{x}張優惠券</span>，共减免<span class="orange-text">{y}</span>',
    couponTips: '已選擇<span class="orange-text">{x}張優惠券</span>，共减免<span class="orange-text">{y}</span>',
    noSelectedTips: '<span class="orange-text">{x}張優惠券</span>可用',
    changeCard: '更換支付卡',
    automaticPay: '授权状态',
    authorized: '已授權',
    unauthorized: '未授權',
    selectedTips: "已選擇<span class='orange-text'>{x}張優惠券</span>，共减免<span class='orange-text'>{y}</span>",
  },
  automaticPay: {
    queryRecords: '关闭查询记录',
    actionTime: '操作时间',
    actionType: '操作类型',
    actionResult: '操作结果',
    resultDesc: '结果描述',
    activate: '开通',
    approved: '通过',
    rejected: '驳回',
    underReview: '审核中',
    autoDeductClose: '是否关闭自动扣款',
    confirmSubmitClose: '请确认是否提交关闭自动扣款的申请？',
    closeNotice: '申请审核通过后，系统将不再自动扣款。若超过缴费截止时间，系统会为您自动退班。',
    cancelReasonPrompt: '请选择取消原因',
    reasonPrompt: '请选择原因',
    otherReason: '其它',
    closeReasonInput: '请填写关闭自动扣款原因',
    installmentPlan: '分期付款计划',
    requestSubmitted: '已提交关闭自动扣款的申请',
    underReviewNotice: '您有审核中的申请，请勿重复提交',
    viewReviewResult: ['您可以在', '中查看审核结果'],
    autoApproved: '自动审核通过',
    turnOffAutoDebit: '是否关闭自动扣款',
    paymentInfo: '付款详情',
    paymentTime: '付款时间',
    paymentStatus: '付款状态',
    paymentResult: '结果描述',
    paymentApproved: '成功',
    paymentRejected: '失败',
  },
}
